import { styled } from 'shared/Houston';

import InfoSolid from '@eduzz/houston-icons/InfoSolid';
import { css } from '@eduzz/houston-styles/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1.5rem;
  width: 100%;
`;

export const TextArea = styled.textarea`
  color: ${({ theme }) => theme.neutralColor.low.medium};
  height: 124px;
  padding: 16px;
  box-sizing: border-box;
  border: 1px solid;
  border-color: ${({ theme }) => theme.neutralColor.high.dark};
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.5);
  resize: none;
  font-family: inherit;
  &:focus-visible {
    border-color: ${({ theme }) => theme.neutralColor.high.dark};
    box-shadow: 0 0 0 0;
    outline: 0;
  }

  max-width: 520px;
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.neutralColor.low.dark};
  font-size: 0.875rem;
  display: flex;
`;

export const InfoSolidStyled = styled(InfoSolid)`
  color: ${({ theme }) => theme.neutralColor.low.light};
  font-size: 0.875rem;
  margin-left: 0.25rem;
`;
